import { ContextMenu } from "lib/@components/context-menu-bar/index.js"
import { isInRegimeFolder } from "routes/facilities/lib/when-parent-item.js"
import { Frag } from "lib/@components/slot/frag.js"
import { CreateTailoredCopyMenuItem } from "routes/schedule/plugins/custom-schedule-from-tailored/components/create-tailored-copy-menu-item.js"
import { isTailoredScheduleNode } from "routes/schedule/plugins/custom-schedule-from-tailored/lib/is-tailored-schedule-node.js"
import { Secure } from "lib/authorization/secure.js"
import { registerFeatureWithDescription } from "lib/features.js"
import { CATEGORY_SCHEDULE_LIBRARY } from "lib/feature-category.js"
import { Feature, isEnabled } from "lib/@components/feature.js"
import { hasDemand } from "lib/authorization/has-demand.js"
import { FEATURE_FLAG_CUSTOM_SCHEDULE_FROM_TAILORED } from "routes/schedule/plugins/custom-schedule-from-tailored/feature-flag-custom-schedule-from-tailored.mjs"

registerFeatureWithDescription({
    numericalId: 3003,
    id: FEATURE_FLAG_CUSTOM_SCHEDULE_FROM_TAILORED,
    name: "custom schedule from tailored",
    descriptionLines: [
        "create custom schedules from a regime's tailored schedule",
        "the resulting schedule is a copy at the time of creation of the tailored schedule",
        "requires demand scheduleEditor to be used",
    ],
    category: CATEGORY_SCHEDULE_LIBRARY,
})

// regime's entry point in the tree navigation (schedule list)
ContextMenu("scheduleItem").plug(
    <Feature feature={FEATURE_FLAG_CUSTOM_SCHEDULE_FROM_TAILORED} if={isCopyableTailoredSchedule}>
        <Secure demand="scheduleEditor" fallback={<Frag />}>
            <CreateTailoredCopyMenuItem />
        </Secure>
    </Feature>
)

function canCopyTailoredSchedules() {
    return hasDemand("scheduleEditor") && isEnabled(FEATURE_FLAG_CUSTOM_SCHEDULE_FROM_TAILORED)
}

function isCopyableTailoredSchedule(context) {
    if (!canCopyTailoredSchedules()) return false
    if (!isInRegimeFolder(context) || context.isRegimeDraftLocked) return false

    // decided here rather than in the item so an untailored schedule contributes no plug at all —
    // ContextMenuBar counts plugs whose `if` passed, so a component that renders nothing would
    // still open an empty menu
    return isTailoredScheduleNode(context)
}
